import { Translation } from "../../hooks/useTranslations";
import { Entity, Price, Version } from "../../types";
import { LeasingCompany } from "../leasingCompanies/types";
import { Manufacturer } from "../manufacturers/types";
import { Subsidiary } from "../subsidiaries/types";
import { Supplier } from "../suppliers/types";
import { User } from "../users/types";

// export type CarPurchaseStatus = {
//   arrivingSoon: number;
//   withExpiredArrivalDate: number;
// };

export type CarPurchaseState = "arrived" | "ordered" | "assigned";

export type CarPurchaseType = "purchase" | "leasing";

export type CarPurchase = Entity & {
  subsidiary: Subsidiary;
  supplier?: Supplier;
  leasingCompany?: LeasingCompany;
  driver?: User;
  manufacturer: Manufacturer;
  model: string;
  plannedArrivalDate: string;
  purchaseDate: string;
  costNet?: Price;
  costGross?: Price;
  state: CarPurchaseState;
  optionals?: string;
  purchaseType: CarPurchaseType;
  hasOptionals: boolean;
  hideArrivalDateNotification: boolean;
  carPlanningId?: string;
};

export type CarPurchaseVersion = Version & {
  subsidiary?: Subsidiary;
  supplier?: Supplier;
  leasingCompany?: LeasingCompany;
  driver?: User;
  manufacturer?: Manufacturer;
  model: string;
  plannedArrivalDate: string;
  purchaseDate: string;
  costNet?: Price;
  costGross?: Price;
  state: CarPurchaseState;
  optionals: string;
  purchaseType: CarPurchaseType;
  hideArrivalDateNotification: boolean;
};

export type UpsertCarPurchase = {
  subsidiaryId: string;
  supplierId?: string;
  leasingCompanyId?: string;
  driverId?: string;
  manufacturerId: string;
  model: string;
  plannedArrivalDate: string;
  purchaseDate: string;
  costNet?: number | null;
  costGross?: number | null;
  currency?: string | null;
  state?: CarPurchaseState;
  optionals?: string;
  purchaseType: CarPurchaseType;
  currentVersionNumber?: number;
  carPlanningId?: string | null;
};

export type PurchaseType = {
  value: CarPurchaseType;
  label: string;
};

export const getPurchaseTypes = (i18n: Translation): PurchaseType[] => [
  { value: "purchase", label: i18n.common.purchase },
  { value: "leasing", label: i18n.common.leasing },
];

export type State = {
  value: CarPurchaseState;
  label: string;
};

export const getCarPurchaseStates = (i18n: Translation): State[] => [
  { value: "ordered", label: i18n.common.ordered },
  { value: "arrived", label: i18n.common.arrived },
  { value: "assigned", label: i18n.common.assigned },
];

export type UpsertCarPurchaseNotification = {
  hideArrivalDateNotification: boolean;
  versionNumber: number;
};

export const isItemArrivingSoon = (plannedArrivalDate: string, state: string): boolean => {
  const d = new Date(plannedArrivalDate);
  const today = new Date();
  const limit = new Date();
  limit.setDate(today.getDate() + 21);
  if (d < limit && d >= today && state != "assigned") {
    return true;
  }

  return false;
};

export const isItemWithExpiredArrivalDate = (plannedArrivalDate: string, state: string): boolean => {
  if (!plannedArrivalDate) return false;
  const d = new Date(plannedArrivalDate);
  const today = new Date();
  const limit = new Date();
  limit.setDate(today.getDate() + 21);
  if (d < limit && d < today && state != "assigned") {
    return true;
  }

  return false;
};
